var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.293 3.50453C25.17 3.01336 24.9196 2.56333 24.5671 2.1999C24.2146 1.83647 23.7724 1.57251 23.2852 1.43467C21.5051 1 14.3848 1 14.3848 1C14.3848 1 7.2645 1 5.48442 1.47607C4.99723 1.6139 4.55503 1.87787 4.2025 2.2413C3.84997 2.60473 3.5996 3.05476 3.47666 3.54593C3.15088 5.35245 2.99152 7.18506 3.00059 9.0207C2.98898 10.8702 3.14835 12.7167 3.47666 14.5369C3.61219 15.0128 3.86818 15.4457 4.21989 15.7938C4.57159 16.1419 5.00713 16.3933 5.48442 16.5239C7.2645 17 14.3848 17 14.3848 17C14.3848 17 21.5051 17 23.2852 16.5239C23.7724 16.3861 24.2146 16.1221 24.5671 15.7587C24.9196 15.3953 25.17 14.9452 25.293 14.4541C25.6162 12.6612 25.7756 10.8425 25.769 9.0207C25.7806 7.17123 25.6213 5.32466 25.293 3.50453Z",
    fill: "#848484",
    stroke: "#848484",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0566 12.4052L18.0075 9.02094L12.0566 5.63672V12.4052Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.3666640232cbc0e4c7fe20edb1231d92.svg";
export { ForwardRef as ReactComponent };